<template>
  <div class="edit-video-box">
    <el-dialog :title="'订单状态编辑'" :visible.sync="dialogVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="90px">
        <el-form-item label="状态说明:" prop="statusDesc">
          <el-input type="textarea" :rows="3" placeholder="请输入状态说明" v-model="params.statusDesc">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="handleOK()" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      targetId: '',
      dialogVisible: false,
      flag: false,
      params: {
        id: '',
        statusDesc: ''
      },
      rules: {
        statusDesc: [{ required: true, message: '请输入状态说明', trigger: 'blur' }],
      }
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false
      this.params.statusDesc = ''
      this.$refs['form'].resetFields()
    },
    // 确认修改
    handleOK() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.flag = true
          this.submitEdit()
        } else {
          return false
        }
      })
    },
    // 提交修改
    submitEdit() {
      API.editStatusText(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '订单状态说明编辑成功！',
            type: 'success'
          })
          this.$emit('handlerEdit')
        } else {
          this.$message.error('订单状态说明编辑失败！')
        }
        this.flag = false
        this.handleClose()
      }).catch(() => {
        this.flag = false
        this.handleClose()
      })
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(row) {
      this.params.id = row.id
      this.params.statusDesc = row.statusDesc || ''
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-video-box {
  .el-input {
    width: 150px;
  }
}
</style>
